import { render } from "./Snackbar.vue?vue&type=template&id=3290eb52&scoped=true"
import script from "./Snackbar.vue?vue&type=script&lang=ts"
export * from "./Snackbar.vue?vue&type=script&lang=ts"

import "./Snackbar.vue?vue&type=style&index=0&id=3290eb52&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3290eb52"

export default script